if(!customElements.get('contact-form')) {
  class ContactForm extends HTMLElement {
  	constructor() {
      super();
      this.querySelector('form').addEventListener('submit', this.contactFormSubmitHandler.bind(this));
      if (location.search.indexOf('customer_posted=true')>-1 && !location.hash) {
        var nearestVisibleForm = Array.from(document.querySelectorAll('[name="form_type"][value="customer"]')).map(x=>x.closest('form')).find(x=>{return $s.isVisible(x)});
        if (nearestVisibleForm) {
          $s.scrollToElement(nearestVisibleForm);
        }
      } else if (location.href.indexOf('/challenge')>-1) {
        window.addEventListener('load', ()=>{
          $s.scrollToElement(document.querySelector('main'));
        }, {once: true})
      }
    }

    contactFormSubmitHandler(e) {
      var self = this;
      var form = self.querySelector('form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];

      errorMsg.style.display = 'none';
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="" || (elem.type=='radio' && !form.querySelector('input[name="'+elem.name+'"]:checked')) || (elem.type=='checkbox' && !elem.checked) ) {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), requiredFields[0]);
      }
      if(error) {
        errorMsg.innerHTML = msg || lngg.general__forms__complete_all_the_fields_message;
        errorMsg.style.display = 'block';
      } else {
        if(!$s.validateEmail(form.querySelector('.email').value)) {
          error = true;
          form.querySelector('.email').classList.add('error');
          errorMsg.style.display = 'block';
          errorMsg.innerHTML = lngg.general__forms__enter_a_valid_email_message;
        }
      }
      if(!error) {
        var onsubmit = form.getAttribute('onsubmit');
        if (onsubmit && onsubmit.indexOf('recaptcha')>-1) {
          self.dispatchEvent(new CustomEvent('submitSuccess'));
          return true;
        }

        var params = {
          data: new FormData(form),
          success: function(data, response){
            if(response.url.includes('/challenge')) {
              form.removeEventListener('submit', self.contactFormSubmitHandler);
              form.submit();
            } else {
              form.querySelector('.form-wrap').style.display = 'none';
              form.querySelector('.success-msg').style.display = 'block';
              self.dispatchEvent(new CustomEvent('submitSuccess'));
            }
          },
          error: function(){
            form.removeEventListener('submit', self.contactFormSubmitHandler);
            form.submit();
          }
        }
        params['url'] = form.getAttribute('action');
        params['type'] = 'text';
        return true;

      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        
      }
    }


  }
  customElements.define('contact-form', ContactForm);
}

if(!customElements.get('klaviyo-newsletter')) {
  class KlaviyoNewsletter extends HTMLElement {
  	constructor() {
      super();
      this.form = this.querySelector('form');
      this.companyId = this.dataset.companyId;
      this.listId = this.dataset.listId;
      this.source = this.dataset.source;
      this.apiUrl = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + this.companyId;
      this.revision = '2025-01-15';
      this.inputEmail = this.form.querySelector('[name="email"]');
      this.inputPhone = this.form.querySelector('[name="phone_number"]');
      this.form.addEventListener('submit', this.submitNewsletterHandler.bind(this));

      if(this.inputPhone){
        this.inputPhone.addEventListener('input', function(event) {
          const phone = event.target; // Get the actual input field
          phone.value = phone.value.replace(/[^0-9]+/g, '');
          if(phone.value.length > 0 && !phone.value.includes('+')) {
            phone.value = `+${phone.value}`;
          }
        });
      }
    }

    submitNewsletterHandler(e) {
      e.preventDefault();
      var self = this;
      var error = false;
      var errorMsg = this.querySelector('.error-msg');
      var msg = '';
      var requiredFields = [];

      errorMsg.style.display = 'none';
      this.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      this.querySelectorAll('.required').forEach((elem)=>{
        if(elem.value=="") {
          error = true;
          elem.classList.add('error');
          if (elem.ariaLabel) {
            requiredFields.push(elem.ariaLabel);
          } else if (elem.placeholder) {
            requiredFields.push(elem.placeholder);
          } else if (elem.labels && elem.labels.length > 0) {
            requiredFields.push(elem.labels[0].innerText);
          }
        }
      });
      if (requiredFields.length==1) {
        msg = lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), requiredFields[0]);
      }
      if(error) {
        errorMsg.innerHTML = msg || lngg.general__forms__complete_all_the_fields_message;
        errorMsg.style.display = 'block';
      } else {
        if(!$s.validateEmail(this.inputEmail.value)) {
          error = true;
          this.inputEmail.classList.add('error');
          errorMsg.style.display = 'block';
          errorMsg.innerHTML = lngg.general__forms__enter_a_valid_email_message;
        }
      }
      if(!error && this.inputPhone && this.inputPhone.value != '' ) {
        if(!$s.validatePhone(this.inputPhone.value)) {
          error = true;
          this.inputPhone.classList.add('error');
          errorMsg.style.display = 'block';
          errorMsg.innerHTML = lngg.general__forms__enter_a_valid_phone_message;
        }
      }
      if(!error) {
        var profileAttributes = {
          "email": this.inputEmail.value,
          "subscriptions": {
            "email": {
              "marketing": {
                "consent": "SUBSCRIBED"
              }
            }
          }
        };
        if(this.inputPhone && this.inputPhone.value != '') {
          profileAttributes.phone_number = this.inputPhone.value;
          profileAttributes.subscriptions.sms = {
            "marketing": {
              "consent": "SUBSCRIBED"
            },
            "transactional": {
              "consent": "SUBSCRIBED"
            }
          };
        }

        var params = {
          "url": this.apiUrl,
          "headers": {'Content-Type': 'application/json', 'revision': this.revision},
          "data": {
            "data": {
              "type": "subscription",
              "attributes": {
                "custom_source": this.source,
                "profile": {
                  "data": {
                    "type": 'profile',
                    "id": this.inputEmail.value,
                    "attributes": profileAttributes
                  }
                }
              },
              "relationships": {
                "list": {
                  "data": {
                    "type": 'list',
                    "id": this.listId
                  }
                }
              }
            }
          },
          "success": function(data, response){
            self.querySelector('.form-wrap').style.display = 'none';
            self.querySelector('.success-msg').style.display = 'block';
          },
          "error": function(){
            errorMsg.innerHTML = 'There has been an error. Please make sure that the phone number includes the country code (+1 for the US), or try again later.';
            errorMsg.style.display = 'block';
          }
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        $s.post(params);

      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        
      }
    }

  }
  customElements.define('klaviyo-newsletter', KlaviyoNewsletter);
}